"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrenchScrewdriver = exports.pencil = exports.add = exports.cross = exports.move = exports.settings = void 0;
// biome-ignore lint: -
exports.settings = require("../../../../assets/images/diagram/settings.png");
// biome-ignore lint: -
exports.move = require("../../../../assets/images/diagram/move.png");
// biome-ignore lint: -
exports.cross = require("../../../../assets/images/diagram/cross.png");
// biome-ignore lint: -
exports.add = require("../../../../assets/images/diagram/add.png");
// biome-ignore lint: -
exports.pencil = require("../../../../assets/images/diagram/pencil.png");
// biome-ignore lint: -
exports.wrenchScrewdriver = require("../../../../assets/images/diagram/wrench-screwdriver.png");
//# sourceMappingURL=flow-diagram.js.map